import { createContext } from "react";

/**
 * Allows accessing CSS variables from JS
 */
const CssVariablesContext = createContext({});

export default CssVariablesContext;
